// extracted by mini-css-extract-plugin
export default {"fallback":"media_fallback__-3RI2"};